module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "dec"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/dedication#dec1"
    }
  }, [_c('span', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgements#ack1"
    }
  }, [_c('span', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ipt01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part01#pt01"
    }
  }, [_c('span', [_vm._v("PART I: GLOBAL NOMADS: SURVIVING THE BURN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "iintro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#intro"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("1. Re-Entry: What Is It?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich01sec01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01sec01"
    }
  }, [_c('span', [_vm._v("Reverse Culture Shock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich01sec02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01sec02"
    }
  }, [_c('span', [_vm._v("Change and Transition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich01sec03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chapter01#ch01sec03"
    }
  }, [_c('span', [_vm._v("Variables of Re-Entry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("2. Re-Entry Stress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich02sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Sources of Stress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich02sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Signs of Cultural Stress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich02sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter02#ch02sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Coping with Re-Entry Stress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("3. Preparing to Re-enter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich03sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Educating Yourself and Others")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich03sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Saying Goodbye")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich03sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Knowing Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich03sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Having Realistic Expectations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich03sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter03#ch03sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Evaluating the Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("4. Relocating")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Identity")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Employment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Finances")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Housing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Family Needs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich04sec06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Social Skills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich04sec07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter04#ch04sec07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Spiritual Needs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("5. Debriefing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Definition of Debriefing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("The Use of Debriefing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("How to Debrief")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("The Power of Debriefing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Children and Debriefing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich05sec06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("How to Follow Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich05sec07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter05#ch05sec07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Judging the Benefits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ipt02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("PART II: THIRD CULTURE KIDS: CATCHING THE WAVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "iintro01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/introduction01#intro01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("6. Who Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich06sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Definition of Third Culture Kid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich06sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Benefits of the TCK Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich06sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Challenges of the TCK Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich06sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Discovering Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich06sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Putting Your Life Back Together")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich06sec06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter06#ch06sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Making Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("7. The Emotional Roller Coaster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich07sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#ch07sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Revisiting the Past")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich07sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter07#ch07sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Processing Emotions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("8. Nuts and Bolts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich08sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("How to Fit In")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich08sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Finances, Feasts, and phones")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich08sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Learning the Language")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich08sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Choosing the Right School")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich08sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Stamping Out Worry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich08sec06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter08#ch08sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Helpful TCK Websites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "page_vi"
    }
  }, [_c('a', {
    attrs: {
      "id": "ich09"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("9. The Third Culture Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich09sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Citizens of the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich09sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Bridging the Gap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a",
    attrs: {
      "id": "ich09sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("The Voyage of Self-discovery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2b",
    attrs: {
      "id": "ich09sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter09#ch09sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Questions and Answers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ipt03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("PART III: ON THE RECEIVING END")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "iintro02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/introduction02#intro02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("10. The Reception Committee")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("A Warm Welcome")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("A Good Listener")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Practical Knowledge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Social and Cultural Illiteracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Practical Provision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich10sec06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Financial Provision")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c1",
    attrs: {
      "id": "ich10sec07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter10#ch10sec07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Advice from Returning Expatriates")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "ich11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("11. The Pilgrim Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich11sec01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#ch11sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Pilgrim’s Progress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich11sec02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#ch11sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("TCKs in the Bible")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c",
    attrs: {
      "id": "ich11sec03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#ch11sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("The “Pedestal” Mentality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2c1",
    attrs: {
      "id": "ich11sec04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter11#ch11sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Moving On")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc20",
    attrs: {
      "id": "inotes"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sgc-1"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc21",
    attrs: {
      "id": "iabout"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/about#about",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0